import script from "./AppAuthBrand.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAuthBrand.vue?vue&type=script&setup=true&lang=ts"

import "./AppAuthBrand.vue?vue&type=style&index=0&id=6928db63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6928db63"]])

export default __exports__